export default "__VITE_ASSET__ClD2SfC6__"